module.exports = __webpack_public_path__ + "img/live6.a7d82806.png";